import React from "react";

function EmptyIcon() {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='98' height='98' fill='none' viewBox='0 0 98 98'>
      <path fill='#FAFAFA' d='M49 98c27.062 0 49-21.938 49-49S76.062 0 49 0 0 21.938 0 49s21.938 49 49 49z'></path>
      <g filter='url(#filter0_ddd_12527_125550)'>
        <path fill='url(#paint0_linear_12527_125550)' d='M31.125 26a3 3 0 013-3h18.087a3 3 0 012.313 1.09l12.663 15.328a3 3 0 01.687 1.91V68a3 3 0 01-3 3h-30.75a3 3 0 01-3-3V26z'></path>
        <path
          stroke='url(#paint1_linear_12527_125550)'
          d='M31.625 26a2.5 2.5 0 012.5-2.5h18.087a2.5 2.5 0 011.927.908l12.663 15.329a2.5 2.5 0 01.573 1.592V68a2.5 2.5 0 01-2.5 2.5h-30.75a2.5 2.5 0 01-2.5-2.5V26z'></path>
      </g>
      <g filter='url(#filter1_ddd_12527_125550)'>
        <path fill='url(#paint2_linear_12527_125550)' d='M60.375 31.118L52.875 23v14.25a3 3 0 003 3h12l-7.5-9.132z'></path>
        <path stroke='url(#paint3_linear_12527_125550)' strokeWidth='0.5' d='M67.346 40H55.875a2.75 2.75 0 01-2.75-2.75V23.639l7.061 7.643L67.346 40z'></path>
      </g>
      <rect width='21' height='3' x='38.625' y='53.75' fill='#CCC' rx='1.5'></rect>
      <rect width='12' height='3' x='43.125' y='47.75' fill='#7e62d1' rx='1.5'></rect>
      <defs>
        <filter id='filter0_ddd_12527_125550' width='48.75' height='60' x='25.125' y='20' colorInterpolationFilters='sRGB' filterUnits='userSpaceOnUse'>
          <feFlood floodOpacity='0' result='BackgroundImageFix'></feFlood>
          <feColorMatrix in='SourceAlpha' result='hardAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'></feColorMatrix>
          <feOffset></feOffset>
          <feComposite in2='hardAlpha' operator='out'></feComposite>
          <feColorMatrix values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0'></feColorMatrix>
          <feBlend in2='BackgroundImageFix' result='effect1_dropShadow_12527_125550'></feBlend>
          <feColorMatrix in='SourceAlpha' result='hardAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'></feColorMatrix>
          <feOffset dy='1'></feOffset>
          <feGaussianBlur stdDeviation='1.5'></feGaussianBlur>
          <feComposite in2='hardAlpha' operator='out'></feComposite>
          <feColorMatrix values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0'></feColorMatrix>
          <feBlend in2='effect1_dropShadow_12527_125550' result='effect2_dropShadow_12527_125550'></feBlend>
          <feColorMatrix in='SourceAlpha' result='hardAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'></feColorMatrix>
          <feOffset dy='3'></feOffset>
          <feGaussianBlur stdDeviation='3'></feGaussianBlur>
          <feComposite in2='hardAlpha' operator='out'></feComposite>
          <feColorMatrix values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0'></feColorMatrix>
          <feBlend in2='effect2_dropShadow_12527_125550' result='effect3_dropShadow_12527_125550'></feBlend>
          <feBlend in='SourceGraphic' in2='effect3_dropShadow_12527_125550' result='shape'></feBlend>
        </filter>
        <filter id='filter1_ddd_12527_125550' width='19' height='22' x='50.875' y='22.25' colorInterpolationFilters='sRGB' filterUnits='userSpaceOnUse'>
          <feFlood floodOpacity='0' result='BackgroundImageFix'></feFlood>
          <feColorMatrix in='SourceAlpha' result='hardAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'></feColorMatrix>
          <feOffset></feOffset>
          <feComposite in2='hardAlpha' operator='out'></feComposite>
          <feColorMatrix values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0'></feColorMatrix>
          <feBlend in2='BackgroundImageFix' result='effect1_dropShadow_12527_125550'></feBlend>
          <feColorMatrix in='SourceAlpha' result='hardAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'></feColorMatrix>
          <feOffset dy='2'></feOffset>
          <feGaussianBlur stdDeviation='1'></feGaussianBlur>
          <feComposite in2='hardAlpha' operator='out'></feComposite>
          <feColorMatrix values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0'></feColorMatrix>
          <feBlend in2='effect1_dropShadow_12527_125550' result='effect2_dropShadow_12527_125550'></feBlend>
          <feColorMatrix in='SourceAlpha' result='hardAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'></feColorMatrix>
          <feOffset dy='0.25'></feOffset>
          <feGaussianBlur stdDeviation='0.5'></feGaussianBlur>
          <feComposite in2='hardAlpha' operator='out'></feComposite>
          <feColorMatrix values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0'></feColorMatrix>
          <feBlend in2='effect2_dropShadow_12527_125550' result='effect3_dropShadow_12527_125550'></feBlend>
          <feBlend in='SourceGraphic' in2='effect3_dropShadow_12527_125550' result='shape'></feBlend>
        </filter>
        <linearGradient id='paint0_linear_12527_125550' x1='49.5' x2='49.5' y1='23' y2='71' gradientUnits='userSpaceOnUse'>
          <stop stopColor='#fff'></stop>
          <stop offset='1' stopColor='#EFEFEF'></stop>
        </linearGradient>
        <linearGradient id='paint1_linear_12527_125550' x1='49.125' x2='49.125' y1='71' y2='25.25' gradientUnits='userSpaceOnUse'>
          <stop stopColor='#fff'></stop>
          <stop offset='1' stopColor='#fff' stopOpacity='0'></stop>
        </linearGradient>
        <linearGradient id='paint2_linear_12527_125550' x1='51.875' x2='59.379' y1='40.25' y2='41.236' gradientUnits='userSpaceOnUse'>
          <stop stopColor='#FAFAFA'></stop>
          <stop offset='1' stopColor='#EDEDED'></stop>
        </linearGradient>
        <linearGradient id='paint3_linear_12527_125550' x1='61.875' x2='60.846' y1='50.397' y2='32.134' gradientUnits='userSpaceOnUse'>
          <stop stopColor='#fff'></stop>
          <stop offset='1' stopColor='#fff' stopOpacity='0'></stop>
        </linearGradient>
      </defs>
    </svg>
  );
}

export default EmptyIcon;